<template>
  <b-card>
    <b-card-body id="providers-card-body">
      <b-button variant="primary" type="button" size="sm" class="mb-2" @click="createFee()">
        <feather-icon icon="PlusIcon" size="15" />
        <span>{{ t('Add New Additional Fee') }}</span>
      </b-button>

      <vue-good-table
        mode="remote"
        :sort-options="{ enabled: false }"
        :total-rows="totalRecords"
        :is-loading.sync="isLoading"
        :show-footer="true"
        :rows="rows"
        :columns="getColumns"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
      >
        {{ rows }}
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'provider.name'">
            {{ props.row.provider.name }}
          </span>
          <span v-if="props.column.field === 'description'">
            {{ props.row.description }}
          </span>
          <span v-if="props.column.field === 'price'">
            {{ props.row.price || '-' }}
          </span>
          <span v-if="props.column.field === 'priceType'">
            {{
              props.row.pricingType === 1
                ? $t('Fixed')
                : props.row.pricingType === 2
                ? $t('Percentage')
                : '-'
            }}
          </span>

          <span v-else-if="props.column.field === 'actions'">
            <span class="d-flex justify-content-center table-icon-buttons">
              <b-button
                :id="`edit-button-${props.row.id}`"
                variant="primary"
                type="button"
                size="sm"
                @click="detailFee(props.row.id)"
              >
                <feather-icon icon="Edit3Icon" size="15" />
                <b-tooltip
                  triggers="hover"
                  :target="`edit-button-${props.row.id}`"
                  :title="t('Edit Providers Infos')"
                  :delay="{ show: 0, hide: 0 }"
                  boundary="viewport"
                />
              </b-button>
              <b-button
                :id="`delete-fee-button-${props.row.id}`"
                variant="danger"
                type="button"
                size="sm"
                @click="deleteProviderFee(props.row.id)"
              >
                <feather-icon icon="XIcon" size="15" />
                <b-tooltip
                  triggers="hover"
                  :target="`delete-fee-button-${props.row.id}`"
                  :title="t('Delete Provider Fee')"
                  :delay="{ show: 0, hide: 0 }"
                  boundary="viewport"
                />
              </b-button>
            </span>
          </span>
        </template>
      </vue-good-table>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BTooltip, BButton } from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { VueGoodTable } from 'vue-good-table';
import { helper } from '@core/mixins/helper.js';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import useService from '@/auth/service/useService';
import store from '@/store/index';

export default {
  components: {
    VueGoodTable,
    BCard,
    BCardBody,
    BTooltip,
    BButton,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent
  },

  mixins: [helper],

  data() {
    return {
      isLoading: false,
      rows: [],
      details: [],
      totalRecords: 0,
      filter: {
        page: 1,
        limit: 10
      }
    };
  },

  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },

    getColumns() {
      if (!this.rows.length) {
        return [];
      }

      return [
        {
          label: this.$t('Name'),
          field: 'provider.name'
        },
        {
          label: this.$t('Description'),
          field: 'description'
        },
        {
          label: this.$t('Price'),
          field: 'price'
        },
        {
          label: this.$t('Pricing Type'),
          field: 'priceType'
        },
        {
          label: this.$t('Actions'),
          field: 'actions'
        }
      ];
    }
  },

  async created() {
    this.loadItems();
  },

  methods: {
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps };
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.filter.page = 1;
      this.updateParams({ limit: params.currentPerPage });
      this.loadItems();
    },

    loadItems() {
      const routerId = this.$route.params.id;

      // const requestData = {};

      this.isLoading = true;

      useService
        .getAllFees(routerId)
        .then(response => {
          this.rows = response.data;
        })
        .finally(() => {
          this.isLoading = false;
        });

      // if(requestData.dateFrom && requestData.dateTo && (new Date(requestData.dateFrom) > new Date(requestData.dateTo))) {
      //   this.showErrorMessage(this.$t('Big Date Error'), this.$t('Unsuccessful'))
      //   return false
      // }
    },

    detailFee(id) {
      let providerId = 0;
      providerId = this.$route.params.id;
      this.$router.push(`/providers/${providerId}/additional-fees/${id}`);
    },

    createFee() {
      const { id } = this.$route.params;
      this.$router.push(`/providers/${id}/additional-fees/create`);
    },

    deleteProviderFee(id) {
      this.$swal({
        title: `${this.$t('Warning')}!`,
        text: `${this.$t('Delete Fee Warning')}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `${this.$t('Yes')}`,
        cancelButtonText: `${this.$t('No')}`,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then(async result => {
        if (result.value) {
          await this.deleteProviderFeeRequest(id)
            .then(response => {
              this.showSuccessMessage(`${response.message || this.$t('Fee Was Deleted')}`);

              this.filter.page = 1;
              this.loadItems();
            })
            .catch(messages => {
              if (typeof messages === 'object' && messages && messages.length) {
                messages.forEach(item => {
                  this.showErrorMessage(item.message);
                });
              }
            });
        }
      });
    },

    async deleteProviderFeeRequest(feeId) {
      const { id } = this.$route.params;
      return useService.deleteProviderFee(id, feeId);
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
